import * as React from 'react';

/**
 * BottomLine — the Rule 37 scannable-verdict callout (RULES_BLOG_POST.md,
 * added 2026-08-26): any comparison/"which one" post must give a reader who
 * skips every paragraph a direct answer via a labeled box, not prose alone.
 * `children` is the one- or two-sentence verdict itself; keep it short enough
 * to read in one glance.
 */
export const BottomLine = ({ children }: { children: React.ReactNode }) => (
  <div className="rounded-xl border border-cyan-200 dark:border-cyan-900 bg-cyan-50 dark:bg-cyan-950/40 p-4 sm:p-5 my-4">
    <div className="mb-2">
      <span className="inline-block px-2.5 py-1 rounded-full text-xs font-bold uppercase tracking-wide bg-cyan-100 dark:bg-cyan-900/60 text-cyan-700 dark:text-cyan-300">
        Bottom line
      </span>
    </div>
    <div className="text-sm sm:text-base font-medium text-slate-800 dark:text-slate-100 leading-relaxed">{children}</div>
  </div>
);
